import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import i18n from 'i18n-js';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { IconButton, Paper, Tab, Tabs, Toolbar } from '@material-ui/core';

import Finances from './components/finances';
import { theme } from 'config/theme';
import Tips from './components/tips';
import Storno from './components/storno';

interface FinanceProps {
    restaurantId?: string;
    isOld?: boolean;
}

enum FinanceView {
    FINANCES = 0,
    TIPS = 1,
    STORNO = 2,
}

export default function Finance(props: FinanceProps) {
    const history = useHistory();
    const [view, setView] = useState<FinanceView>(FinanceView.FINANCES);
    return (
        <Paper>
            <Toolbar
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    //borderBottom: `1px solid ${theme.palette.grey['300']}`,
                    marginTop: 0,
                }}
            >
                <IconButton
                    aria-label="delete"
                    size="small"
                    style={{ color: theme.palette.common.black }}
                    //className={classes.iconButton}
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon fontSize="inherit" />
                </IconButton>
                <Tabs
                    id="hide-in-print"
                    value={view}
                    onChange={(_, newValue) => setView(newValue)}
                    variant="scrollable"
                    aria-label="wrapped label tabs example"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label={i18n.t('navigationTabs.finances')} value={FinanceView.FINANCES} />
                    <Tab label={i18n.t('navigationTabs.tips')} value={FinanceView.TIPS} />
                    <Tab label={i18n.t('navigationTabs.storno')} value={FinanceView.STORNO} />
                </Tabs>
            </Toolbar>
            {view === FinanceView.FINANCES && <Finances {...props} />}
            {view === FinanceView.TIPS && <Tips />}
            {view === FinanceView.STORNO && <Storno />}
        </Paper>
    );
}
